import { FiCopy, handleCopy } from "@/components/common/commonFunction/handleCopy";
import React, { useState } from "react";

function ToLowerCase() {
  const [changelo, setChangelo] = useState("");
  const [copy, setCopy] = useState(false);
  const [text, setText] = useState("");
  const [errors, setErrors] = useState("");

  const handleOnErase = () => {
    setText("");
    setChangelo("");
    setCopy(false);
  };

  const handleOnChange = (event) => {
    setErrors("");
    setCopy(false);
    setText(event.target.value);
    setChangelo("");
  };

  const handleLoClick = () => {
    if (!text || text.trim() === "") return setErrors("* Please enter text.");
    let newText = text.toLowerCase();
    setChangelo(newText);
    setCopy(false);
  };

  return (
    <>
      <div className="main-globally-counter-box">
        {text?.length > 0 && (
          <div className="color-picker-icon">
            <i
              className="fa-solid fa-eraser"
              title="Clear"
              onClick={handleOnErase}
            ></i>
          </div>
        )}
        <div className="counter-text-area">
          <textarea
            className={errors && "error-input"}
            placeholder="Enter uppercase text"
            value={text}
            onChange={handleOnChange}
          />
          <span>{errors}</span>
        </div>
      </div>

      <div className="button lowercase-center-alignment-new">
        <button onClick={handleLoClick}>Convert To Lowercase</button>
      </div>
      {changelo?.length > 0 && (
        <div className="main-globally-counter-box">
          <div className="copy-textarea-icon-alignment">
            <FiCopy onClick={() => handleCopy(changelo)} />
            {copy && changelo && (
              <div>
                {" "}
                <span>Copied</span>
              </div>
            )}
          </div>

          <div className="counter-text-area">
            <textarea value={changelo} className="text-black" readOnly />
            <div className="new-copy-icon-text-style-alignment position-unset"></div>
          </div>
        </div>
      )}
    </>
  );
}
export default ToLowerCase;
